__turbopack_context__.v({
  "bannerAction": "SummitBanner-module-scss-module__J4fMkW__bannerAction",
  "bannerArrow": "SummitBanner-module-scss-module__J4fMkW__bannerArrow",
  "bannerCard": "SummitBanner-module-scss-module__J4fMkW__bannerCard",
  "bannerCity": "SummitBanner-module-scss-module__J4fMkW__bannerCity",
  "bannerClose": "SummitBanner-module-scss-module__J4fMkW__bannerClose",
  "bannerCta": "SummitBanner-module-scss-module__J4fMkW__bannerCta",
  "bannerDate": "SummitBanner-module-scss-module__J4fMkW__bannerDate",
  "bannerDetails": "SummitBanner-module-scss-module__J4fMkW__bannerDetails",
  "bannerDot": "SummitBanner-module-scss-module__J4fMkW__bannerDot",
  "bannerEyebrow": "SummitBanner-module-scss-module__J4fMkW__bannerEyebrow",
  "bannerLocation": "SummitBanner-module-scss-module__J4fMkW__bannerLocation",
  "bannerMain": "SummitBanner-module-scss-module__J4fMkW__bannerMain",
  "bannerPerks": "SummitBanner-module-scss-module__J4fMkW__bannerPerks",
  "bannerTime": "SummitBanner-module-scss-module__J4fMkW__bannerTime",
  "bannerTitle": "SummitBanner-module-scss-module__J4fMkW__bannerTitle",
  "countItem": "SummitBanner-module-scss-module__J4fMkW__countItem",
  "countNumber": "SummitBanner-module-scss-module__J4fMkW__countNumber",
  "countSeparator": "SummitBanner-module-scss-module__J4fMkW__countSeparator",
  "countUnit": "SummitBanner-module-scss-module__J4fMkW__countUnit",
  "countdown": "SummitBanner-module-scss-module__J4fMkW__countdown",
  "countdownLabel": "SummitBanner-module-scss-module__J4fMkW__countdownLabel",
  "countdownWrap": "SummitBanner-module-scss-module__J4fMkW__countdownWrap",
  "summitBannerWrapper": "SummitBanner-module-scss-module__J4fMkW__summitBannerWrapper",
});
